import { GetRequest, PutRequest } from "../service"

const ControllerName = 'Notification'

export const GetUserNotification = (lang) => {
    return GetRequest(ControllerName + `/getUserNotifications`)
}

export const GetUnreadMsgCount = (lang) => {
    return GetRequest(ControllerName + `/getUnReadUserNoticicationsCount`)
}

export const UpdateNotificationStatus = (ID, lang) => {
    return PutRequestt(ControllerName + `/markAsRead/${ID}`, {})
}



